export const calculateItemIndex = (page, itemsPerPage, itemIndex) => {
    if (!page || !itemsPerPage) return itemIndex + 1;
    const firstIndex = (page - 1) * itemsPerPage;
    return firstIndex + itemIndex + 1;
};
